import 'notifyjs-browser';

export const toastOptions = {
  autoHide: true,
  autoHideDelay: 3500,
  clickToHide: true,
  elementPosition: 'bottom right',
  globalPosition: 'bottom right'
};

export default {
  show: function (msg, type) {
    toastOptions.className = type + ' closable';
    $.notify(msg, toastOptions);
  }
};
